<template>
  <div>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <label style="font-size: 15px !important">Arquivo de Orçamento e Edificações</label>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-row>
            <v-col cols="12">
              <v-alert dense outlined type="info" color="blue">
                <div>
                  <a href="javascript:void(0)" @click="baixarArquivoObrigacoesEspeciais()">Clique aqui</a>
                  para baixar o modelo para a importação.
                  <br />
                  OBS: O arquivo enviado precisa estar no formato
                  <b>UTF-8</b>
                  .
                </div>
              </v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <validation-provider v-slot="{ errors }">
                <v-file-input
                  v-model="arquivoObrigacoesEspeciaisFileObj"
                  label="Arquivo CSV"
                  placeholder="Selecione um arquivo CSV"
                  outlined
                  accept=".csv"
                  truncate-length="30"
                  :loading="arquivoObrigacoesEspeciaisUploading"
                  loader-height="4"
                  :success="arquivoObrigacoesEspeciaisId && arquivoObrigacoesEspeciaisFileObj ? true : false"
                  :error-messages="errors"
                  @change="uploadNewFile($event)"
                  @click:clear="clearInputsArquivo()"
                />
              </validation-provider>
              <input type="hidden" name="upload-arquivo-obrigacoes-especiais" :value="arquivoObrigacoesEspeciaisId" />
            </v-col>
          </v-row>
          <v-row class="mb-n5 mt-n2 mx-auto">
            <v-col cols="12" class="pl-n1 pt-0">
              <parametros-arquivo-csv
                :delimitador.sync="arquivoObrigacoesEspeciaisDelimitador"
                :involucro.sync="arquivoObrigacoesEspeciaisInvolucro"
                :escape.sync="arquivoObrigacoesEspeciaisEscape"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  import SimulacoesLaudosIncrementaisService from '@/services/SimulacoesLaudosIncrementaisService';
  import ArquivosService from '@/services/ArquivosService';

  export default {
    components: {
      ParametrosArquivoCsv: () => import('@/components/general/GeneralParametrosArquivoCsv.vue')
    },

    data: () => ({
      cabecalhoArquivo: ['Id_BaseContabil', 'Valor_VNR']
    }),

    computed: {
      arquivoObrigacoesEspeciaisId: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.arquivoObrigacoesEspeciais.id;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', { arquivoObrigacoesEspeciais: { id: value } });
        }
      },
      arquivoObrigacoesEspeciaisFileObj: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.arquivoObrigacoesEspeciais.fileObj;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', { arquivoObrigacoesEspeciais: { fileObj: value } });
        }
      },
      arquivoObrigacoesEspeciaisUploading: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.arquivoObrigacoesEspeciais.uploading;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', { arquivoObrigacoesEspeciais: { uploading: value } });
        }
      },
      arquivoObrigacoesEspeciaisDelimitador: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.arquivoObrigacoesEspeciais.delimitador;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', { arquivoObrigacoesEspeciais: { delimitador: value } });
        }
      },
      arquivoObrigacoesEspeciaisInvolucro: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.arquivoObrigacoesEspeciais.involucro;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', { arquivoObrigacoesEspeciais: { involucro: value } });
        }
      },
      arquivoObrigacoesEspeciaisEscape: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.arquivoObrigacoesEspeciais.escape;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', { arquivoObrigacoesEspeciais: { escape: value } });
        }
      }
    },

    methods: {
      baixarArquivoObrigacoesEspeciais() {
        this.$toast.info('Processando...', '', {
          position: 'topRight',
          timeout: 1250
        });

        SimulacoesLaudosIncrementaisService.baixarArquivoObrigacoesEspeciais()
          .then(async (res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;

            link.setAttribute('download', 'Arquivo Orçamento e Edificações Modelo.csv');
            document.body.appendChild(link);
            link.click();
          })
          .catch((err) => {
            this.$toast.error('Erro ao baixar arquivo modelo do sistema', '', {
              position: 'topRight'
            });
            console.error(err);
          });
      },

      uploadNewFile(arquivo) {
        if (!arquivo) {
          this.clearInputsArquivo();
          return true;
        }

        this.arquivoObrigacoesEspeciaisId = '';
        this.arquivoObrigacoesEspeciaisUploading = true;

        let formDataWithFile = new FormData();
        formDataWithFile.append('file', arquivo);

        ArquivosService.uploadFile(formDataWithFile, {})
          .then(async (response) => {
            await this.validaHeader(
              response.data.arquivoId,
              this.arquivoObrigacoesEspeciaisDelimitador,
              this.arquivoObrigacoesEspeciaisInvolucro,
              this.arquivoObrigacoesEspeciaisEscape,
              this.cabecalhoArquivo
            );

            this.arquivoObrigacoesEspeciaisId = response.data.arquivoId;
          })
          .catch((err) => {
            if (err?.data?.error_code == 120 || err?.data?.error_code == 121) {
              this.$toast.error(err.data.erro, '', {
                position: 'topRight',
                timeout: 6000
              });
            } else {
              this.$toast.error('Erro no upload do arquivo.', '', {
                position: 'topRight'
              });
              console.error('Erro ao fazer upload: ', err);
            }

            this.arquivoObrigacoesEspeciaisFileObj = null;
          })
          .finally(() => (this.arquivoObrigacoesEspeciaisUploading = false));
      },

      clearInputsArquivo() {
        this.arquivoObrigacoesEspeciaisId = '';
        this.arquivoObrigacoesEspeciaisFileObj = null;
        this.arquivoObrigacoesEspeciaisDelimitador = ';';
        this.arquivoObrigacoesEspeciaisInvolucro = '"';
        this.arquivoObrigacoesEspeciaisEscape = '"';

        this.$forceUpdate();
      },

      validaHeader(arquivoId, delimitador, involucro, escape, cabecalhoEsperado) {
        return ArquivosService.validarHeaderCSV(arquivoId, {
          delimitador,
          involucro,
          escape,
          cabecalhoEsperado
        }).catch((err) => {
          throw err;
        });
      }
    }
  };
</script>
